const GNB_CACHE_TTL_MS = 5 * 60 * 1000
const gnbMenuCache = new Map()
const pendingGnbRequests = new Map()

/**
 * Cache public GNB data in the Nuxt server process so each SSR request does not
 * call the corner API. Concurrent cache misses for the same corner share one
 * request. The cache is process-local; each server worker warms its own entry.
 */
export async function getSsrGnbMenuData (api, exhCnrId) {
  const cacheKey = exhCnrId
  const cached = gnbMenuCache.get(cacheKey)

  if (cached && cached.expiresAt > Date.now()) {
    return cached.data
  }

  if (pendingGnbRequests.has(cacheKey)) {
    return pendingGnbRequests.get(cacheKey)
  }

  const request = api.post('/ds/cnr/selCnrList', { exhCnrId })
    .then((response) => {
      const data = response?.data?.data
      if (!Array.isArray(data)) {
        throw new Error('Invalid GNB menu response')
      }

      gnbMenuCache.set(cacheKey, {
        data,
        expiresAt: Date.now() + GNB_CACHE_TTL_MS
      })
      return data
    })
    .catch((error) => {
      // Keep the last good menu available if the API fails during refresh.
      if (cached) {
        return cached.data
      }
      throw error
    })
    .finally(() => {
      pendingGnbRequests.delete(cacheKey)
    })

  pendingGnbRequests.set(cacheKey, request)
  return request
}
